/* eslint react/no-multi-comp: "off" */
import PropTypes from 'prop-types';

import React from 'react';

const getDisplayName = (WrappedComponent) =>
  WrappedComponent.displayName || WrappedComponent.name || 'Component';

export const withClusterer = (WrappedComponent) => (class extends React.Component {
  static displayName = `WithClusterer(${getDisplayName(WrappedComponent)})`;
  static contextTypes = {clusterer: PropTypes.object};

  render() {
    if (!this.context.clusterer) return <WrappedComponent {...this.props} />;
    return <WrappedComponent clusterer={this.context.clusterer} {...this.props} />;
  }
});

export const withMap = (WrappedComponent) => (class extends React.Component {
  static displayName = `WithMap(${getDisplayName(WrappedComponent)})`;
  static contextTypes = {map: PropTypes.object};

  render() {
    if (!this.context.map) return null;
    return <WrappedComponent map={this.context.map} {...this.props} />;
  }
});

export const withOverlay = (WrappedComponent) => (class extends React.Component {
  static displayName = `WithOverlay(${getDisplayName(WrappedComponent)})`;

  static contextTypes = {
    bounds: PropTypes.object,
    positionToPixel: PropTypes.func,
  };

  render() {
    if (!this.context.positionToPixel) return null;
    return (
      <WrappedComponent
        bounds={this.context.bounds}
        positionToPixel={this.context.positionToPixel}
        {...this.props}
      />
    );
  }
});



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/utils.js